import React, { useEffect, useState } from 'react'
import moment from 'moment'
import Body from '../Typography/Body/Body'
import { Flex, Text } from 'theme-ui'
import { Space } from '..'

const Timer = ({
  countdownEndTime,
  countdownText,
  TimelineEvents,
  onTimeChange,
  endText,
  wrapTimer,
  ...rest
}) => {
  const calculateTime = () => {
    var difference = moment(new Date(countdownEndTime)).subtract(Date.now())
    return difference
  }

  const getTimeObj = difference => {
    var time = {}
    if (difference > 0) {
      time = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      }
    }
    return time
  }

  const [timeLeft, setTimeLeft] = useState(0)

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(getTimeObj(calculateTime()))
      onTimeChange && onTimeChange(timeLeft)
      // setDifference(calculateTime())
    }, 1000)
    return () => clearTimeout(timer)
  })
  return (
    <Flex
      sx={{
        textAlign: 'center',
        width: '100%',
        height: '100%',
        // bg: getBGColor(),
        color: 'inherit',
        alignItems: 'center',
        height: '100%',
        color: rest.color,
        justifyContent: 'center',
      }}
    >
      {calculateTime() > 0 ? (
        <Flex sx={{ flexDirection: wrapTimer && 'column' }}>
          {countdownText}
          <Space width={5} />
          {timeLeft.days > 0 &&
            `${getExtraZero(timeLeft.days)}${timeLeft.days}d `}
          {timeLeft.hours > 0 &&
            `${getExtraZero(timeLeft.hours)}${timeLeft.hours}h `}
          {timeLeft.minutes &&
            `${getExtraZero(timeLeft.minutes)}${timeLeft.minutes}m `}
          {timeLeft.seconds &&
            `${getExtraZero(timeLeft.seconds)}${timeLeft.seconds}s `}
        </Flex>
      ) : (
        <Text sx={{ color: 'inherit' }}>{endText}</Text>
      )}
    </Flex>
  )
}

const getExtraZero = remaining => (remaining < 10 ? 0 : '')

export default Timer
